module.exports = __webpack_public_path__ + "static/img/RUPS1612RT_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RUPS1612RT_1.png
// module id = VW+/
// module chunks = 0